var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 209,
    height: 209,
    viewBox: "0 0 209 209",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_23592",
    "data-name": "Group 23592",
    transform: "translate(-66 -1357)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_23563",
    "data-name": "Group 23563"
  }, /*#__PURE__*/React.createElement("g", {
    id: "INC_Cloud_1",
    transform: "translate(-1021 -304)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_943",
    "data-name": "Ellipse 943",
    transform: "translate(1087 1661)",
    fill: "#fff",
    stroke: "#0050ad",
    strokeWidth: 15
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 104.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.5,
    cy: 104.5,
    r: 97,
    fill: "none"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_49983",
    "data-name": "Path 49983",
    d: "M-6240.577-104.6l-52.09,24.6s-1.1-13.266-5.057-13.953S-6240.577-104.6-6240.577-104.6Z",
    transform: "translate(6455.177 1644)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "EDGE",
    transform: "translate(107 1406)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_21197",
    "data-name": "Group 21197",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_36029",
    "data-name": "Path 36029",
    d: "M0,50.267a61.82,61.82,0,0,1,1.571-6.432,27.2,27.2,0,0,1,14.54-16.023,1.581,1.581,0,0,0,1.057-1.654A27.393,27.393,0,0,1,41.531.171c12.8-1.3,23.595,4.891,28.77,16.51a3.588,3.588,0,0,0,.187.342c2.356-.183,4.656-.539,6.951-.508a24.156,24.156,0,0,1,17.725,7.57,3.085,3.085,0,0,0,2.709,1.1,26.493,26.493,0,0,1,20.209,7.194c8.28,7.828,11.119,17.461,7.747,28.33-3.357,10.819-11.153,17.125-22.349,19.05-2.945.506-6.02.261-9.036.356-.486.015-.973,0-1.578,0V81.55q0,13.44,0,26.88c0,2.048-.477,2.514-2.566,2.514q-26.75,0-53.5,0c-2.061,0-2.534-.476-2.534-2.547q0-13.379,0-26.757V80.113c-.7,0-1.34,0-1.983,0-4.1.032-8.22.2-12.179-1.08C8.85,75.384,2.137,67.806.228,56.131.177,55.817.077,55.511,0,55.2V50.267M34.266,76.561V75.01q0-20.1,0-40.2c0-1.988.566-2.545,2.584-2.545q26.691,0,53.383,0c2.1,0,2.632.532,2.632,2.621q0,20.163,0,40.327v1.449c2.312,0,4.422.015,6.531,0a24,24,0,0,0,23.775-28.679A24.329,24.329,0,0,0,96.139,28.794a2.377,2.377,0,0,1-2.455-1.009c-5.652-7.26-14.935-9.162-23.03-7.061-1.892.491-2.446.252-3.142-1.6a24.222,24.222,0,0,0-46.9,8.285c-.013,2.037-.234,2.27-2.128,3.11C9.548,34.478,4.37,41.337,3.6,50.985,2.863,60.207,6.747,67.5,14.449,72.731c6,4.07,12.781,4.236,19.817,3.83M89.335,35.8H37.844V57.6H89.335ZM37.831,107.4H89.324v-21.8H37.831ZM89.3,61.217H37.809V82.032H89.3Z",
    transform: "translate(0 0)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36030",
    "data-name": "Path 36030",
    d: "M136.906,135.244a5.941,5.941,0,1,1,5.98-5.929,5.9,5.9,0,0,1-5.98,5.929",
    transform: "translate(-87.349 -82.528)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36031",
    "data-name": "Path 36031",
    d: "M208.48,140.15c-2.178,0-4.355.008-6.533,0-1.3-.006-2.033-.6-2.058-1.621-.026-1.068.733-1.7,2.1-1.7q6.593-.011,13.185,0c1.3,0,2.033.595,2.057,1.62.025,1.071-.729,1.7-2.095,1.7-2.217.01-4.435,0-6.652,0",
    transform: "translate(-133.114 -91.681)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36032",
    "data-name": "Path 36032",
    d: "M142.885,283.548a5.941,5.941,0,1,1-5.924-5.987,5.889,5.889,0,0,1,5.924,5.987",
    transform: "translate(-87.347 -185.397)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36033",
    "data-name": "Path 36033",
    d: "M208.557,294.347c-2.217,0-4.435.01-6.652,0-1.293-.008-2.016-.623-2.015-1.664s.73-1.654,2.021-1.657q6.652-.014,13.3,0c1.293,0,2.016.622,2.014,1.663s-.725,1.65-2.019,1.658c-2.217.013-4.435,0-6.652,0",
    transform: "translate(-133.115 -194.577)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36034",
    "data-name": "Path 36034",
    d: "M136.959,212.344a5.941,5.941,0,1,1,5.928-5.981,5.895,5.895,0,0,1-5.928,5.981",
    transform: "translate(-87.349 -134.108)",
    fill: "#005cbe"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_36035",
    "data-name": "Path 36035",
    d: "M208.44,217.248c-2.178,0-4.355.01-6.533,0-1.293-.008-2.017-.622-2.016-1.663s.728-1.656,2.019-1.658q6.652-.014,13.3,0c1.293,0,2.016.621,2.016,1.661s-.723,1.652-2.017,1.66c-2.257.013-4.514,0-6.771,0",
    transform: "translate(-133.115 -143.344)",
    fill: "#005cbe"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdge);
export default __webpack_public_path__ + "static/media/edge.8ea490b5f8f4a6615dc0234c0aed2c78.svg";
export { ForwardRef as ReactComponent };